import React from "react";
import { BarChart2 } from "lucide-react";
export default function ReportsPage() {
  const reports = [
    "जिल्हानिहाय अहवाल",
    "तालुकानिहाय अहवाल",
    "शाळानिहाय अहवाल",
    "पदनामनिहाय अहवाल",
    "पुरस्कारनिहाय अहवाल",
    "सर्वोच्च गुणप्राप्त शिक्षक",
    "न्यूनतम गुणप्राप्त शिक्षक",
    "प्रलंबित पडताळणी अहवाल",
    "प्रलंबित मंजुरी अहवाल",
  ];
  return (
    <div className="p-4 sm:p-7">
      <h1 className="text-2xl font-normal mb-1" style={{ fontFamily: "serif" }}>
        अहवाल व निर्यात
      </h1>
      <p className="text-sm text-slate-500 mb-5">
        आवश्यक अहवाल तयार करून Excel/PDF/CSV स्वरूपात निर्यात करा
      </p>
      <div
        className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3.5"
      >
        {reports.map((r) => (
          <div
            key={r}
            className="bg-white border border-slate-200 rounded-xl p-4 flex items-center gap-3.5 cursor-pointer hover:shadow-md"
          >
            <div className="w-12 h-12 rounded-full bg-blue-50 text-blue-600 border-2 border-blue-100 flex items-center justify-center">
              <BarChart2 size={18} />
            </div>
            <div>
              <div className="text-xs font-semibold">{r}</div>
              <div className="text-[10px] text-slate-400">
                Excel · PDF · CSV
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
